import * as Yup from "yup";
import { TFunction } from "i18next";
import { buildCloneInitialDisplayNameWithLimit, CLONE_DISH_NAME_MAX_LENGTH } from "../utils/cloneNameUtils";
import { PartialMenuCategory } from "../../../interfaces/meMenuInterfaces/interfaces";
import { EditMenuService } from "../../MenuEditContentPage/service/editMenuService";

export interface IStep {
    key: string;
    label: string;
}

export interface IPickedCategoryNames {
    id: number;
    name: string;
    parentName: string | null;
    nameOrigin?: string | null;
    parentNameOrigin?: string | null;
}

export const getSteps = (t: any): IStep[] => [
    { key: "menu", label: t("menu") },
    { key: "category", label: t("Category") },
    { key: "dish", label: t("Dishes") },
    { key: "view", label: t("Preview") },
    { key: "generate", label: t("To publish") },
];

export const getCategoryName = (categoryData?: PartialMenuCategory): string => {
    return categoryData?.parentCategory
        ? EditMenuService.resolveTranslatedName(
              categoryData.parentCategory.name,
              categoryData.parentCategory.nameOrigin
          )
        : EditMenuService.resolveTranslatedName(categoryData?.name, categoryData?.nameOrigin);
};

export const getSubCategoryName = (categoryData?: PartialMenuCategory): string | null => {
    return categoryData?.parentCategory
        ? EditMenuService.resolveTranslatedName(categoryData.name, categoryData.nameOrigin) || null
        : null;
};

export const getInitialDishName = (apiName: string | null | undefined, t: TFunction): string => {
    return buildCloneInitialDisplayNameWithLimit(apiName, t, CLONE_DISH_NAME_MAX_LENGTH);
};

export const validationCloneDishSchema = (t: TFunction) =>
    Yup.object().shape({
        name: Yup.string().required(t("validation.required")),
        categories: Yup.array()
            .of(Yup.number().required())
            .min(1, t("validation.required"))
            .required(t("validation.required")),
    });
